import React from 'react'
import PhotoPlayer from 'aria-viewer/players/photoplayer/photoPlayer'
import { WithForwardRef } from 'aria-viewer/common'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withStateHandlers from 'recompose/withStateHandlers'

const styleSheet = {
    container: {
        width: ({ width, style }) => width || style.width,
        height: ({ height, style }) => height || style.height,
    },

    img: {
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '100%',
        maxWidth: ({ naturalWidth }) => naturalWidth,
        maxHeight: ({ naturalHeight }) => naturalHeight,
        backgroundSize: ({ fit }) => fit,
    },
}

const style = injectSheet(styleSheet)

const state = withStateHandlers(({ fit = 'initial', onLoad }) => ({ fit, onLoad }), {
    handleOnLoad: ({ onLoad }) => e => {
        const img = e.target
        const { naturalWidth, naturalHeight } = img

        let fit

        // If the image is portrait, then let's fit the image
        if (naturalWidth < naturalHeight) fit = 'contain'
        else fit = 'cover'

        onLoad && onLoad(e, img)

        return { fit, naturalWidth, naturalHeight }
    },
})

const AspectHelper = ({ forwardRef, children, sizes, options, handleOnLoad, width, height, classes }) => (
    <div>
        <PhotoPlayer
            className={classes.container}
            imgClassName={classes.img}
            ref={forwardRef}
            sizes={sizes}
            onLoad={handleOnLoad}
            options={options}
            width={width}
            height={height}
            alt={'Photo of ' + (options.alt || 'main media.')}
        />
        {children}
    </div>
)

export default compose(
    WithForwardRef,
    state,
    style,
    pure
)(AspectHelper)
